import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField from '../../../../utils/InputField';
import { handleSmtpTestMailOpe } from '../BasicOperation';

function SmtpTestMailModal({ data, handleReload, setShowSmtpModal }) {
    const { companyName, fromMail, replayToEmail, port, password } = data;
    const { setMessage } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        CompanyName: companyName || '',
        FromMail: fromMail || '',
        ReplayToEmail: replayToEmail || '',
        SMTPHostname: data.smtpHostname || '',
        Port: port || '',
        Password: password || ''
    });

    const handleTestSmtp = (e) => {
        e?.preventDefault();
        setLoading(true);
        handleSmtpTestMailOpe(formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                setShowSmtpModal(false);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleTestSmtp}>
            <div className="flex flex-col gap-y-2 mb-4">
                <InputField
                    label="Company Name"
                    name="CompanyName"
                    placeholder="Type Company Name..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="From Mail"
                    name="FromMail"
                    placeholder="Type From Mail..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="Replay To Email"
                    name="ReplayToEmail"
                    placeholder="Type Replay To Email..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="SMTP Hostname"
                    name="SMTPHostname"
                    placeholder="Type SMTP Hostname..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="Port"
                    name="Port"
                    placeholder="Type Port..."
                    formData={formData}
                    readOnly
                />

                <InputField
                    label="Test Email"
                    name="TestEmail"
                    placeholder="Ex: test@example.com"
                    formData={formData}
                    onChange={(e) => setFormData((d) => ({ ...d, TestEmail: e.target.value }))}
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={() => setShowSmtpModal(false)} />
                <ButtonPrimary title="Test" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default SmtpTestMailModal;
